import { APICore } from './apiCore';

const api = new APICore();

interface ReplyPayload {
    reply_name: string;
    type: 'Text' | 'Image' | 'Video' | 'Document';
    text_reply?: string;
    reply_file?: File;
}

/* CREATE REPLY */
export function CreateReply(formData: FormData): Promise<any> {
    return api.create('/reply_library', formData);
}

/* LIST */
export function showreply_library() {
    return api.show('/reply_library/list');
}

/* DETAILS */
export function showreply_libraryDetails(id: string) {
    return api.show(`/reply_library/${id}`);
}
export function delreply_libraryDetails(id: string) {
    return api.get(`/reply_library/${id}`);
}

/* IMPORT */
// export function ImportContact(data: FormData): Promise<any> {
//     return api.create('/reply_library/import', data);
// }

/* UPDATE */
export function updatereply_library(id: string, data: FormData) {
    return api.create(`/reply_library/${id}`, data);
}
